import { Card } from '@mui/material'
import { SxProps, useTheme } from '@mui/material/styles'
import { memo, ReactNode } from 'react'

interface QuestionCardRootProps {
  children: ReactNode
  sx?: SxProps
}

export const QuestionCardRoot = memo<QuestionCardRootProps>(({ children, sx }) => {
  const theme = useTheme()

  return (
    <Card
      data-qa="question-card-root"
      elevation={2}
      sx={{
        position: 'relative',
        width: '100%',
        padding: 4,
        display: 'flex',
        flexDirection: 'column',
        gap: 3,
        borderRadius: 2,
        border: `1px solid ${theme.palette.divider}`,
        '&:hover': {
          boxShadow: theme.shadows[8],
        },
        transition: theme.transitions.create(['box-shadow'], {
          duration: theme.transitions.duration.short,
        }),
        ...sx,
      }}>
      {children}
    </Card>
  )
})

QuestionCardRoot.displayName = 'QuestionCardRoot'
